import { ViewerSetViewEvent } from '../types/ViewerEvents.type';
import { AssetViewerViewMapper } from '../helpers/AssetViewerViewMapper';
export class LinkService {
    constructor(viewer, eventBus) {
        this.viewer = viewer;
        this.eventBus = eventBus;
    }
    setViewer(viewer) {
        this.viewer = viewer;
    }
    set view(view) {
        this.viewer.currentView = view;
        this.eventBus.dispatch(new ViewerSetViewEvent({ assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(view) }));
    }
}
//# sourceMappingURL=LinkService.js.map